import { faMessage } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule } from '@domain-group/suit-theme'

import useConversation from '@hooks/useConversation'

import type { OrderRequestOptions } from '@models/types'

import ConversationContainer from '@components/ConversationContainer'

export const icon = faMessage

interface ConversationProps {
  customOptions: {
    queryParams: {
      campaign_id?: number,
    },
    customization: {
      display_mode?: string,
      title?: string,
    },
    requestOptions: OrderRequestOptions,
  },
}

const Conversations = (props: ConversationProps) => {
  const {
    customOptions,
    customOptions: {
      queryParams,
    },
  } = props

  const { campaign_id: campaignId } = queryParams

  const { customization } = customOptions
  const { title } = customization || {}

  const { loading } = useConversation()

  return (
    <DashboardModule
      boxProps={{ marginBottom: 0 }}
      loading={loading}
      title={title || 'Conversations'}
    >
      {!loading && campaignId && (
        <ConversationContainer
          boxProps={{
            borderColor: 'lineColor',
            marginTop: 0,
            padding: 'large',
          }}
          commentsBoxProps={{ maxHeight: '400px' }}
          conversation={{
            campaign_id: campaignId,
            subject_id: campaignId,
            subject_type: 'Campaign',
          }}
          requestOptions={{
            include_conversation_comments: true,
          }}
        />
      )}
    </DashboardModule>
  )
}

export default Conversations
